import { Tag } from "./tag";
import { cn } from "../lib/utils";
import { ArrowUp, ArrowDown, ArrowRight } from "lucide-react";
import { Icon, IconType } from "./icon";

interface StatsCardProps {
  title: string;
  trend?: "up" | "down" | "neutral";
  trendValue?: number;
  children: React.ReactNode;
  className?: string;
  description1?: string;
  description2?: string;
  icon?: IconType;
}

export function StatsCard({
  title,
  trend,
  trendValue,
  children,
  className,
  description1,
  description2,
  icon,
}: StatsCardProps) {
  const TrendIcon =
    trend === "up" ? ArrowUp : trend === "down" ? ArrowDown : ArrowRight;
  return (
    <div
      className={cn(
        "flex flex-col gap-1.5 border border-gray-200 rounded-xl p-4 bg-white shadow-xs justify-between",
        className ?? ""
      )}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 justify-center mb-2 text-gray-500">
          {icon && <Icon icon={icon} className="size-4" />}
          <h1 className="text-sm font-normal">{title}</h1>
        </div>
        {trend && trendValue && (
          <div>
            <Tag
              variant={
                trend === "up"
                  ? "success"
                  : trend === "down"
                  ? "primary"
                  : "info"
              }
            >
              <TrendIcon className="size-4" />
              {trendValue}
            </Tag>
          </div>
        )}
      </div>
      <h2 className="text-2xl font-bold text-gray-900 mb-4 flex-1">
        {children}
      </h2>
      {(description1 || description2) && (
        <div className="flex flex-col gap-1">
          {description1 && (
            <span className="text-sm text-gray-500 font-bold text-gray-700">
              {description1}
            </span>
          )}
          {description2 && (
            <span className="text-sm text-gray-500">{description2}</span>
          )}
        </div>
      )}
    </div>
  );
}
